import Vue from 'vue';
import Vuex from 'vuex';

// POLYFILLS
require('core-js/es6/promise');
require('core-js/es6/array');

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
});
